export default __webpack_public_path__ + "static/media/samen-plant.d83ce5c5.webp";